/// <amd-module name="VSS/Features/Charts/AreaRange" />
import * as Highcharts from "highcharts";
import * as Charts_Contracts from "VSS/Features/Charts/Contracts";
import { AxialChartImplementation } from "VSS/Features/Charts/Internal/AxialChartImplementations";
import { ChartTypesRegistry } from "VSS/Features/Charts/Internal/ChartTypesRegistry";
import * as Charts_Resources from "VSS/Features/Charts/Resources";

/** A point object with additional fields specific to Area Range */
interface AreaRangeExtendedPointObject extends Highcharts.Point {
    /** The low or minimum value for the data point. */
    low: number;
    /** The high or maximum value for the data point. */
    high: number;
}

class AreaRangeChartImplementation extends AxialChartImplementation {
    public mapDataPointsToTooltipLineItems(points: Charts_Contracts.DataPoint[]): Charts_Contracts.TooltipLineItem[] {
        return points.map(point => {
            const high = Number(point.values[1]).toLocaleString(navigator.language);
            const low = Number(point.values[0]).toLocaleString(navigator.language);

            return {
                styleType: {
                    color: point.color,
                    type: Charts_Contracts.TooltipLineItemMarkerType.Square
                },
                text: `${low} - ${high}`
            } as Charts_Contracts.TooltipLineItem;
        });
    }

    public interpretPointAsValuesForTooltip(point: AreaRangeExtendedPointObject): (string | number)[] {
        return [point.low, point.high];
    }
}
ChartTypesRegistry.getInstance().registerChartType({
    chartTypeName: Charts_Contracts.ChartTypesConstants.AreaRange,
    constructor: AreaRangeChartImplementation,
    userFacingChartTypeName: Charts_Resources.ChartType_A11yLabel_AreaRange
});
